import React from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { Row, Col } from 'reactstrap';
import LicenseContent from './DriverEqipContent';
//import ProgressBar from '../../../components/ProgressBar';
import _get from 'lodash/get';
import ProgressBar from '../../../components/ProgressBar';

export class DriverEqipContainer extends React.Component {
  render() {
    return (
      <div>
        <Row>
          <Col xs="12">
            <ProgressBar percentage={50} />
          </Col>

          <Col xs='12'>
            <LicenseContent />
          </Col>
        </Row>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    business: _get(state, 'app.business', {}),
  };
};
export default withRouter(connect(mapStateToProps, {})(DriverEqipContainer));
